<app-split-wrapper [dynamicComponents]="dynamicComponents" (close)="onClose($event)">
  <ng-content></ng-content>
</app-split-wrapper>
